import React from "react";
import Link from "next/link";
import Srcset from "@/components/common/Srcset";
const facebook = (
  <Link target="_blank" rel="noopener noreferrer" className="social-icon" tabIndex={0} href="https://www.facebook.com/olivela">
    <Srcset
      className="ga_footer_social_media_text"
      svgFile={true}
      src="images/Icons/Fb.svg"
      requirePath={true}
      height="19"
      width="19"
      alt="Facebook"
      lazyLoad={true}
    />
  </Link>
);

export const instagram = (
  <Link target="_blank" rel="noopener noreferrer" className="social-icon" tabIndex={0} href="https://www.instagram.com/olivela/">
    <Srcset
      className="ga_footer_social_media_text"
      svgFile={true}
      src="images/Icons/IG.svg"
      requirePath={true}
      height="19"
      width="19"
      alt="Instagram"
      lazyLoad={true}
    />
  </Link>
);

export const pintrest = (
  <Link target="_blank" rel="noopener noreferrer" className="social-icon" tabIndex={0} href="https://in.pinterest.com/olivelaco/">
    <Srcset
      className="ga_footer_social_media_text"
      svgFile={true}
      src="images/Icons/Pinterest.svg"
      requirePath={true}
      height="19"
      width="19"
      alt="Pinterest"
      lazyLoad={true}
    />
  </Link>
);

export const tiktok = (
  <Link target="_blank" rel="noopener noreferrer" className="social-icon" tabIndex={0} href="https://www.tiktok.com/@olivela?_t=8ZNOV5DiNjp&_r=1">
    <Srcset
      className="ga_footer_social_media_text"
      svgFile={true}
      src="images/Icons/tiktok-logo-4500.svg"
      requirePath={true}
      height="19"
      width="19"
      alt="Tiktok"
      lazyLoad={true}
    />
  </Link>
);

export default facebook;
